<script setup lang="ts">
import { useRouter } from 'vue-router';
import { FhCard, FhTitle } from '@fareharbor-com/beacon-vue';
import { QueryParamName } from '@/common/constants/items';
import type { Coordinates } from '@/common/constants/regionsHomePage';

const router = useRouter();

const props = defineProps({
  imageUrl: {
    type: String,
    required: true,
  },
  regionName: {
    type: String,
    required: true,
  },
  searchParams: {
    type: String,
    required: true,
  },
  neCoordinates: {
    type: Object as () => Coordinates,
    required: true,
  },
  swCoordinates: {
    type: Object as () => Coordinates,
    required: true,
  },
});

const regionClick = () => {
  router.push({
    name: 'item-list',
    query: {
      [QueryParamName.LOC_SEARCH]: props.searchParams,
      ne_lat: props.neCoordinates.lat.toString(),
      ne_lng: props.neCoordinates.lng.toString(),
      sw_lat: props.swCoordinates.lat.toString(),
      sw_lng: props.swCoordinates.lng.toString(),
    },
  });
};
</script>

<template>
  <div class="cursor-pointer" @click="regionClick">
    <FhCard class="card" :style="{ backgroundImage: `url(${props.imageUrl})` }">
      <div class="overlay">
        <FhTitle color="inverted">{{ props.regionName }}</FhTitle>
      </div>
    </FhCard>
  </div>
</template>

<style scoped>
.card {
  @apply relative w-full h-[250px] bg-cover bg-center rounded-2xl overflow-hidden shadow-lg;
}

.overlay {
  @apply absolute inset-0 bg-black/50 text-white p-5 flex flex-col justify-end;
}

.title {
  margin: 0;
  font-size: 1.5rem;
}
</style>
